import { useEffect } from 'react';
import { SearchItem } from '../types';

interface UseMappingContentProps {
  searchParams: URLSearchParams;
  view: string;
  tab: string;
  searchItems: SearchItem[];
  setMappingContent: (content: any) => void;
}

export const useMappingContent = ({
  searchParams,
  view,
  tab,
  searchItems,
  setMappingContent,
}: UseMappingContentProps) => {
  useEffect(() => {
    const hasSearchParams = searchParams.toString() !== '';
    if (hasSearchParams && ['/examples', '/search'].includes(location.pathname)) {
      const newView = searchParams.get('view');
      const newTab = searchParams.get('tab');

      if (newView === view && newTab === tab) return;
    }

    setMappingContent((prevContent: any) => ({
      ...prevContent,
      isActive: false,
    }));
  }, [window.location.pathname, window.location.search, view, tab, setMappingContent]);

  useEffect(() => {
    setMappingContent((prevContent: any) => ({
      ...prevContent,
      isActive: false,
    }));
  }, [searchItems, setMappingContent]);
};
